// ThemeContext.tsx
import React, { createContext, useContext, useEffect, useState } from 'react';

type Theme = 'light' | 'dark';
interface ThemeContext {
  theme: Theme;
  toggleTheme: () => void;
}

const ctx = createContext<ThemeContext | undefined>(undefined);

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [theme, setTheme] = useState<Theme>(() => {
    // читаем сохранённый
    return (localStorage.getItem('theme') as Theme) || 'light';
  });

  const toggleTheme = () => setTheme(t => (t === 'light' ? 'dark' : 'light'));

  // при изменении — сохраняем и ставим класс на <body>
  useEffect(() => {
    localStorage.setItem('theme', theme);
    document.body.classList.toggle('dark-mode', theme === 'dark');
  }, [theme]);

  return <ctx.Provider value={{ theme, toggleTheme }}>{children}</ctx.Provider>;
};

export function useTheme() {
  const theme = useContext(ctx);
  if (!theme) throw new Error('useTheme must be inside ThemeProvider');
  return theme;
}
